import { useState } from "react";
import AsyncTypeahead, { TypeHeadBase } from "./AsyncTypeahead";
import { createPatientApi } from "../api-helpers/PatientApiHelper";
import { useNavigate } from "react-router-dom";
import { formatDateToMMDDYYYY } from "../helper/dateFormatter";

export const HeaderSearch = () => {
  const [patientsList, setPatientTypeHeadList] = useState<TypeHeadBase[]>([]);
  const patientApi = createPatientApi();
  const navigate = useNavigate();

  
  const searchPatients = async (query: any) => {
    if (!query) {
      setPatientTypeHeadList([]);
      return;
    }
    try {
      const response = await patientApi.patientsControllerSearchPatient(query);
      const results = response.data.map((result: any) => {
        const [year, month, day] = result.infoDate.split("-");
        result.infoDate = formatDateToMMDDYYYY(new Date(year, month - 1, day));
        return {
          key: result.key, // Use id as the key
          value: `${result.value || 'N/A'} | ${result.info1 || 'N/A'} | ${ result.infoDate || 'N/A'}`, // Display name with wellinksId and DOB
      }});
      setPatientTypeHeadList(results);
    } catch (error) {
      console.error("Error fetching coaches:", error);
    }
  };

  const selectPatient = async (selected: any) => {
    if(!selected?.key)
      return;
    const patientId = selected?.key;
    navigate(`/patients/${patientId}/summary`);
    
  };

  return (
    <AsyncTypeahead
      name="Search Patient"
      options={patientsList}
      callback={searchPatients}
      onSelect={selectPatient}
      placeholder={"Search by Name, Wellinks ID, Phone, or DoB"}
      required={false}
    />
  );
};
